import React, { useContext } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { auth } from './firebaseConfig'; // Adjust path if needed
import { StudentContext } from './StudentContext'; // Adjust path

const ProtectedRoute = ({ children }) => {
  const { isLoading } = useContext(StudentContext);
  const isLoggedIn = localStorage.getItem('isLoggedIn') === 'true'; // Kiểm tra từ localStorage
  const user = auth.currentUser; // Kiểm tra auth state

  if (isLoading) {
    return <div>Đang tải dữ liệu...</div>;
  }

  if (!isLoggedIn || !user) {
    return <Navigate to="/login" replace />;
  }

  // Nếu đã login, render children (Outlet cho nested routes)
  return children ? children : <Outlet />;
};

export default ProtectedRoute;